import { apiClient } from '@/client'
export default {
  namespaced: true,
  state: {
    isLoading: false,
    data: {},
  },
  getters: {
    isLoading: state => state.isLoading,
    parc: state => state.data.snapshots ? state.data.snapshots.parc : [],
    faces: state => state.data.snapshots ? state.data.snapshots.faces : [],
    bookings: state => state.data.snapshots ? state.data.snapshots.bookings : [],
    incidents: state => state.data.snapshots ? state.data.snapshots.incidents : [],
    interventions: state => state.data.snapshots ? state.data.snapshots.interventions : [],
    print: state => state.data.timeseries ? state.data.timeseries.print : [],
    displays: state => state.data.timeseries ? state.data.timeseries.displays : [],
  },
  mutations: {
    STATS_REQUEST: (state, payload) => {
      state.isLoading = true
    },
    STATS_SUCCESS: (state, payload) => {
      state.data = payload
      state.isLoading = false
    },
    STATS_ERROR: (state, payload) => {
      state.isLoading = false
    },
  },
  actions: {
    getStats: ({ commit }) => {
      commit('STATS_REQUEST')
      apiClient.fetchAll('stats')
        .then(response => {
          commit('STATS_SUCCESS', response)
        })
        .catch(error => {
          commit('STATS_ERROR', error)
        })
    },
  },
}
